module.exports = __webpack_public_path__ + "img/scandcq.70b335af.jpg";